import { sha256Hex } from './sha256';

// The "don't ask again on this browser" token lives in localStorage, since it
// must outlive the tab, unlike the session. One key per user, so two people
// sharing a PC do not overwrite each other's. Private windows and blocked
// storage throw: the sign-in then just asks for the code.
async function storageKey(username: string): Promise<string> {
  return 'uv.trust.' + (await sha256Hex(username.trim().toLowerCase())).slice(0, 16);
}

export async function readTrustedBrowser(username: string): Promise<string | null> {
  try {
    return localStorage.getItem(await storageKey(username));
  } catch {
    return null;
  }
}

export async function saveTrustedBrowser(username: string, token: string): Promise<void> {
  try {
    localStorage.setItem(await storageKey(username), token);
  } catch {
    // Not remembered: the next sign-in asks for the code again.
  }
}

// The Id the server lists this browser under: the hex SHA-256 of its token.
export async function trustedBrowserId(username: string): Promise<string | null> {
  const token: string | null = await readTrustedBrowser(username);

  return token ? sha256Hex(token) : null;
}

export async function forgetTrustedBrowser(username: string): Promise<void> {
  try {
    localStorage.removeItem(await storageKey(username));
  } catch {
    // Nothing stored to remove.
  }
}
